/**
 * a callback for mapKV
 * @callback mapKVCallback
 * @param {any} item    the object[key] value
 * @param {string} key  the current key
 */

/**
 * Map over an object, and return either an object (with adjusted values)
 * or return an array of mapped values
 * @param  {object}        obj             Object to mapView over
 * @param  {mapKVCallback} callback        a callback to run
 * @param  {Boolean}       [retArr=false]  return an array or the object props
 * @return {object|array}                  Object or Array of the result
 */
export default function mapKV(obj, fn, retArr = false) {
  return Object.keys(obj).reduce(
    (acc, item) => (
      (retArr) ?
        acc.concat(fn(obj[item], item)) :
        { ...acc, [item]: fn(obj[item], item) }
    ),
    (retArr) ? [] : {}
  );
}



// WEBPACK FOOTER //
// ./app/utils/object/mapKV.js